export default __webpack_public_path__ + "static/seven-e5eff0469b8266d3a01e01ca556ef951.jpg";